import React from "react";
import { TableLegendItem } from "../../../models/table/TableLegendItem";
import { Link } from 'react-router-dom'
import Restricted from "../../../contexts/PermissionProvider/RestrictedWrapper";
import { store } from "../../../store/store";
import DefaultRecord from '../../../images/DefaultRecord.svg';
import '../../../../src/tooltip.css';
import Tooltip from "../../Tooltip/Tooltip";

const getRouteNameFromPath = (path: string) => {
    const splitPath = path.split('/');
    return splitPath[2];
}
export const wrapName = (row, route, legendItems?: TableLegendItem[], tooltiptext?: string) => {
    const routeName = getRouteNameFromPath(store.getState().router.location.pathname);
    const rowName = !!route.rowPath.path ?
        (<Restricted to={`update.${routeName}.element`} alternativeComponent={<Link className='inline-block ml-2' to={`${route.rowPath.path}${row.id}`}>{row.name}</Link>}>
            <span className="ml-2">{row.name}</span>
        </Restricted>)
        : <span className="ml-2">{row.name}</span>;
 
    // Find a matching state in the legend
    const legendItem = !!legendItems && !!row && row.status !== undefined
        ? legendItems.find((item) => +item.value === +row.status)
        : undefined;

    // Show the state
    if (!!legendItem) {
        return (
            <div className="flex flex-row items-center">
                <img
                    src={legendItem.imageIcon}
                    title={legendItem.label}
                    className=" w-5 "
                    alt="" />
                {rowName}
            </div>
        );
    }
    return (
        <div className="flex flex-row items-center">
            <div className="whitespace-no-wrap">
                {row.name && !!!row.transactionType ? // Hide initials on transaction report no other better way might need some refactor
                <svg className={` bg-no-repeat ${row.isDefault ? '' : 'pt-1'}`} height={25} width={25} >
                    <circle fill="#908E8E" cx="10" cy="10" r="10"></circle>
                    <text
                        fill="#ffffff"
                        fontSize="13"
                        textAnchor="middle"
                        x="10"
                        y="14">
                        {row.name ? row.name[0] : row.id}
                    </text>

                    {row.isDefault ?
                       <>
                            <image
                                width={13}
                                fill="#4CBB17"
                                y={12}
                                x={12}
                                href={DefaultRecord}/>
                       </>
                     : null}
                </svg> : null}
            </div>
            <Tooltip show={!!row.isDefault} text={tooltiptext ?? ""} direction="top" contentPositionX="start" usePortal>
                <div id='nameColumnId'>
                    {rowName}
                </div>
            </Tooltip>
        </div>
    );
};

